/**
 * @memberOf Tee
 * @class Image and url to draw images.
 * @param {Tee.Chart} chart The parent chart this image object belongs to.
 */
export class ChartImage {
	constructor(chart) {
		this.url = ""
		this.repeat = "no-repeat"
		this.backFill = false
		this.chart = chart
		this.visible = true
		this.image = null
	}

	tryDraw(x, y, width, height) {
		if (!this.image) {
			this.image = new Image()

			this.image.onload = () => {
				this.chart.draw()
			}
		}

		if (this.image.src === "") {
			this.image.src = this.url
		} else if (this.chart.ctx.drawImage) {
			if (this.repeat === "repeat") {
				const pattern = this.chart.ctx.createPattern(this.image, "repeat")
				this.chart.ctx.fillStyle = pattern
				this.chart.ctx.fillRect(x, y, width, height)
			} else {
				this.chart.ctx.drawImage(this.image, x, y, width, height)
			}
		}
	}
}
